module.exports = __webpack_public_path__ + "assets/img/logo1.f6b47bb9.png";